(() => {
  const observed = new WeakSet();
  const resize = new ResizeObserver(entries => entries.forEach(({target}) => measure(target)));
  function measure(track) {
    const speed = Number(getComputedStyle(document.documentElement).getPropertyValue('--ribbon-speed')) || 40;
    track.style.setProperty('--ribbon-duration', (track.getBoundingClientRect().width / 2 / speed) + 's');
  }
  function init() {
    document.querySelectorAll('.announcement__track,.marquee__track').forEach(track => {
      measure(track);
      if (!observed.has(track)) { resize.observe(track); observed.add(track); }
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-accordion] > button');
    if (!button) return;
    const open = button.parentElement.toggleAttribute('data-open');
    button.setAttribute('aria-expanded', String(open));
    const sign = button.querySelector('.faq-sign');
    if (sign) sign.textContent = open ? '−' : '+';
  });
  init();
  document.fonts.ready.then(init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', init, {passive:true});
})();
